// extracted by mini-css-extract-plugin
export var loader = "loader-module--loader--dYhXb";
export var spin = "loader-module--spin--1HfJA";